export default {
    INPUT_CHANGE: 'InputChanged',
    INPUT_RANGE_CHANGE: 'InputRangeChanged',
};
